<template>
    <v-app>
        <v-dialog v-model="dialog" max-width="800">
            <v-card>
              <v-toolbar dark>
                <v-card-title class="headline">
                  {{ `${edit ? 'Update' : 'Add'}` }}  leave category
                  <hr>
                </v-card-title>

                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-btn icon  @click="cancelForm">
                    <i class="fas fa-times"></i>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Title" v-model="leave_category.title" outlined dense>
                            </v-text-field>
                            <span class="text-danger" v-if="$v.leave_category.title.$error">This information is required</span>
                        </v-col>
                        <v-col cols="12">
                            <label for="description">Description</label>
                            <ckeditor id="description" v-model="leave_category.description"
                                      :config="editorConfig"></ckeditor>
                            <span class="text-danger" v-if="$v.leave_category.description.$error">This information is required</span>

                        </v-col>
                        <v-col cols="12">
                            <v-select outlined dense :items="applicable_for" v-model="leave_category.applicable_users"
                                      item-text="name"
                                      multiple
                                      item-value="value" label="Applicable users">
                            </v-select>
                            <span class="text-danger" v-if="$v.leave_category.applicable_users.$error">This information is required</span>
                        </v-col>

                        <v-col cols="3">
                            <v-switch v-model="leave_category.is_active" label="Active"></v-switch>
                        </v-col>
                        <v-col cols="3">
                            <v-switch v-model="leave_category.auto_approval" label="Auto approval"></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <div class="text-right float-right">
                                <v-btn depressed @click="cancelForm" class="text-gray btn btn-standard cancel-btn">
                                    Cancel
                                </v-btn>
                                <v-btn depressed :loading="isBusy" @click="createOrUpdate"
                                       class="text-white ml-2 btn btn-primary ">
                                    Save
                                </v-btn>
                            </div>

                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>

</template>
<script>
    import {required} from "vuelidate/lib/validators";
    import AcademicClassService from "@/core/services/academic-class/AcademicClassService";
    import LeaveCategoryService from "@/core/services/leave/leave-category/LeaveCategoryService";

    const academicClassService = new AcademicClassService();
    const leaveCategoryService = new LeaveCategoryService();
    export default {
        name: 'create-leave-category',
        validations: {
            leave_category: {
                title: {required},
                description: {required},
                applicable_users: {required},

            }
        },
        data() {
            return {
                academic_class: [],
                dialog: false,
                edit: false,
                isBusy: false,
                search: {
                    active: "active",
                    is_parent: 1,
                },
                applicable_for: [
                    {
                        name: 'Student',
                        value: 'student'
                    },
                    {
                        name: 'Teachers',
                        value: 'teacher'
                    }, {
                        name: 'Staff',
                        value: 'staff'
                    },
                    {
                        name: 'All',
                        value: 'all'
                    }
                ],
                editorConfig: {
                  versionCheck: false,
                    toolbar: [['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'Link', 'NumberedList', 'BulletedList']]
                },
                leave_category: {
                    title: null,
                    description: null,
                    applicable_users: null,
                    is_active: true,
                    auto_approval: false
                },
            };
        },
        mounted() {

        },
        methods: {
            showModal(id = null) {
                if (id) {
                    this.edit = true
                    this.__getSingle(id)
                }else{
                    this.resetForm()
                }
                this.dialog = true;
            },
            hideModal() {
                this.dialog = false;
            },
            cancelForm(){
                this.resetForm();
                this.hideModal();
            },
            toggleModal() {
                this.$refs["my-modal"].toggle("#toggle-btn");
            }, __getSingle(id) {
                leaveCategoryService.show(id).then(response => {
                    this.leave_category = response.data.leave_category
                    this.leave_category.applicable_users = this.leave_category.applicable_users.split(',');
                })
            },

            // generateFd() {
            //     // console.log(this.leave_category)
            //     let fd = new FormData();
            //     for (let key in this.leave_category) {
            //         if (key == "is_active" && this.leave_category["is_active"]) {
            //             fd.append("is_active", this.leave_category ? 1 : 0);
            //         } else {
            //             if (this.leave_category[key] != null) {
            //                 fd.append(key, this.leave_category[key]);
            //             }
            //         }
            //     }
            //     return fd;
            // },
            createOrUpdate() {

                this.$v.leave_category.$touch();
                if (this.$v.leave_category.$error) {
                    setTimeout(() => {
                        this.$v.leave_category.$reset();
                    }, 3000);
                } else {
                    if (this.leave_category.applicable_users.length) {
                        this.leave_category.applicable_users = this.leave_category.applicable_users.join(',');
                    }
                    let fd = this.leave_category;
                    if (this.edit) {
                        this.__update(fd);
                    } else {
                        this.__create(fd);
                    }
                }
            },
            __update(fd) {
                this.isBusy = true;
                leaveCategoryService
                    .update(this.leave_category.id, fd)
                    .then(response => {
                        this.isBusy = false;
                        this.$snotify.success("Information updated");
                        this.$emit("refresh_leave_category");
                        this.resetForm();
                        this.hideModal();
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        // console.log(error);
                    });
            },


            __create(fd) {
                this.isBusy = true;
                leaveCategoryService
                    .store(fd)
                    .then((response) => {
                        // console.log(response)
                        this.isBusy = false;
                        this.resetForm();
                        this.$emit("refresh_leave_category");
                        this.$snotify.success("Information added");
                        this.hideModal();
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        // console.log(error);
                    });
            },
            resetForm() {
                this.$v.leave_category.$reset();
                this.edit = false;
                this.leave_category = {
                    title: null,
                    description: null,
                    applicable_users: null,
                    is_active: true,
                    auto_approval: false
                };
            }
        }
    };
</script>
